module.exports = __webpack_public_path__ + "static/media/site-logo-small.f3cecbce.png";